import type { FC, ReactNode } from "react";
import { twMerge } from "tailwind-merge";

import { IconText } from "./IconText";

export type EmptyCardProps = {
  icon: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  className?: string;
};

export const EmptyCard: FC<EmptyCardProps> = ({ icon, title, description, className }) => {
  return (
    <div className={twMerge("flex flex-col gap-4 rounded-lg bg-black-tint-97 p-4", className)}>
      <IconText iconStart={icon} text={title} />
      {description && <div className="body-s">{description}</div>}
    </div>
  );
};
